import { IChat } from "../hooks/chats/index.type";

export const groupMessagesByDate = (messages: IChat[]) => {
    const groupedMessages: { [key: string]: IChat[] } = {};


    messages.forEach((msg) => {
 
      const messageDate = new Date(Number(msg.timestamp)*1000)
      const today = new Date();
      const yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);

      let formattedDate = messageDate.toLocaleDateString();

      if (messageDate.toDateString() === today.toDateString()) {
        formattedDate = "Today";
      } else if (messageDate.toDateString() === yesterday.toDateString()) {
        formattedDate = "Yesterday";
      }

      if (!groupedMessages[formattedDate]) {
        groupedMessages[formattedDate] = [];
      }
      groupedMessages[formattedDate].push(msg);
    });

    return groupedMessages
  }